/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_Account_MappingInputs */

const en_page_title_account_mapping = /** @type {(inputs: Page_Title_Account_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account mapping`)
};

const nl_page_title_account_mapping = /** @type {(inputs: Page_Title_Account_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekeningkoppeling`)
};

/**
* | output |
* | --- |
* | "Account mapping" |
*
* @param {Page_Title_Account_MappingInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_account_mapping = /** @type {((inputs?: Page_Title_Account_MappingInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_Account_MappingInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_account_mapping(inputs)
	return en_page_title_account_mapping(inputs)
});